import { ModuleRegistry, AllCommunityModule } from 'ag-charts-community';
import { AgCharts } from 'ag-charts-react';
import { Box } from 'components/ui';
import { useState } from 'react';
import styled from 'styled-components';

ModuleRegistry.registerModules([AllCommunityModule]);
const ChartContainer = styled(Box)<{ $height: number }>`
  width: 100%;
  height: ${({ $height }) => ($height ? `${$height}px` : '100%')};
  min-width: 0;
  min-height: 0;
  position: relative;
`;

interface ComboChartProps {
  data?: any[];
  title?: string;
  showTitle?: boolean;
  height?: number;
  legendPosition?: 'top' | 'right' | 'bottom' | 'left';
  showLegend?: boolean;
  innerRadius?: number;
  categoryKey?: string;
  seriesKey?: string;
  colors?: string[];
}

export const ComboChart = ({ height = 400, data = [] }: ComboChartProps) => {
  const [styleContainer, setStyleContainer] = useState<HTMLDivElement | null>(
    null
  );

  if (!data || data.length === 0) return null;

  const clicksColor = '#5090dc';
  const impressionsColor = '#ffa03a';

  const options: any = {
    data: data,
    legend: { enabled: false },
    tooltip: {
      enabled: true,
    },
    series: [
      {
        type: 'bar',
        xKey: 'date',
        yKey: 'views',
        yName: 'Clicks',
        yKeyAxis: 'clicks',
        tooltip: {
          enabled: true,
          renderer: (params: any) => ({
            content: `Clicks: ${params.datum.views.toLocaleString()}`,
          }),
        },
      },
      {
        type: 'line',
        xKey: 'date',
        yKey: 'impressions',
        yName: 'Impressions',
        yKeyAxis: 'impressions',
        tooltip: {
          enabled: true,
          renderer: (params: any) => ({
            content: `Impressions: ${params.datum.impressions.toLocaleString()}`,
          }),
        },
      },
    ],
    axes: {
      x: {
        type: 'category',
        position: 'bottom',
      },
      clicks: {
        type: 'number',
        position: 'left',
        title: {
          enabled: true,
          text: '■ Clicks',
          color: clicksColor,
        },
        nice: true,
        min: 0,
      },
      impressions: {
        type: 'number',
        position: 'right',
        title: {
          enabled: true,
          text: '━ Impressions',
          color: impressionsColor,
        },
        nice: true,
        min: 0,
      },
    },
  };
  return (
    <ChartContainer ref={setStyleContainer} $height={height}>
      {styleContainer && <AgCharts options={{ ...options, styleContainer }} />}
    </ChartContainer>
  );
};
